import jsCookie from 'js-cookie';

export default function getAuthHeader() {

  let token = localStorage.getItem('token'); // Get token from local storage

  if (!token) {
    token = jsCookie.get('token'); // Check cookie if token is not in local storage
    
    if(token) {
      localStorage.setItem('token', token); // Save to local storage if exists
    }
  }

  return {
    Authorization: `Bearer ${token}`
  };
}
